/**
 * Hero Content v1 (Legacy)
 * 
 * Wrapper around the legacy ListingContent component.
 * Used when listing-hero-redesign flag is off.
 */

import { useRef } from 'react';
import LegacyListingContent from 'components/pages/address/public/components/listing-content';
import type Listing from 'data/listing';
import { ComplianceRequirement } from 'types/compliance';
import type { TenantId } from '@tenants/types';

export interface HeroContentV1Props {
  tenantId: TenantId;
  listing: Listing;
  complianceRequirement: ComplianceRequirement;
  shouldScramble?: boolean;
  priceHistoryLabel?: string;
  onPriceHistoryClick?: () => void;
  priceHistoryRef?: React.RefObject<HTMLDivElement>;
  showFavouriteToggle?: boolean;
  listingSource?: string;
}

export function HeroContentV1({
  tenantId,
  listing,
  complianceRequirement,
  shouldScramble = false,
  priceHistoryLabel,
  priceHistoryRef: externalRef,
  showFavouriteToggle = true,
  listingSource,
}: HeroContentV1Props) {
  const localRef = useRef<HTMLDivElement>(null);
  const priceHistoryRef = externalRef || localRef;

  // Build address string with unit number (if present)
  const streetWithUnit = listing.unitNumber 
    ? `${listing.unitNumber}-${listing.streetAddress}`
    : listing.streetAddress;
  
  const address = [streetWithUnit, listing.city, listing.province]
    .filter(Boolean)
    .join(', ');

  return (
    <LegacyListingContent
      tenantId={tenantId}
      listing={listing}
      complianceRequirement={complianceRequirement}
      priceHistoryRef={priceHistoryRef}
      shouldScramble={shouldScramble}
      showPriceHistoryBtn={!!priceHistoryLabel}
      showFavouriteToggle={showFavouriteToggle}
      showsInfoIcon={true}
      address={address}
      addressPath={listing.addressPath || undefined}
      propertyType={listing.seoType}
      listingSource={listingSource}
    />
  );
}
